'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HeaderBar = require('./HeaderBar');

var _HeaderBar2 = _interopRequireDefault(_HeaderBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HeaderBar2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-header-bar/index.js
// module id = 1997
// module chunks = 0